let config = {
  api_url: process.env.REACT_APP_API_URL,
  insta_api: "https://graph.instagram.com/me/media",
  insta_token: process.env.REACT_APP_INSTA_TOKEN,
  azure_object_url: process.env.REACT_APP_AZURE_OBJECT_URL,
};

export default config;
